export const tastingTags = ["全部", "甜口", "咸香", "辣味", "酸爽", "坚果", "怀旧"];

export const tastingItems = [
  {
    id: 1,
    name: "海盐焦糖曲奇",
    brand: "麦穗烘焙",
    tags: ["甜口"],
    surprise: 4.6,
    price: "¥12",
    note: "掰开有微流心，甜度克制，配无糖茶刚好，是全盒里最先被吃完的一款。",
  },
  {
    id: 2,
    name: "川香麻辣锅巴",
    brand: "蜀香坊",
    tags: ["辣味"],
    surprise: 4.8,
    price: "¥9",
    note: "青花椒香气突出，入口先脆后麻，辣度中等，越嚼米香越明显。",
  },
  {
    id: 3,
    name: "咸蛋黄酥",
    brand: "南岸点心",
    tags: ["咸香"],
    surprise: 4.3,
    price: "¥15",
    note: "酥皮层次清晰，咸蛋黄馅心扎实不齁，回温后香气更足。",
  },
  {
    id: 4,
    name: "柠檬海盐气泡糖",
    brand: "沁柠",
    tags: ["酸爽"],
    surprise: 3.9,
    price: "¥8",
    note: "入口有轻微跳感，酸度靠前，适合解腻，含久了会偏甜一点。",
  },
  {
    id: 5,
    name: "蜂蜜黄油杏仁",
    brand: "果之谷",
    tags: ["坚果"],
    surprise: 4.5,
    price: "¥18",
    note: "颗粒分明不粘手，咸甜交织，独立小包装方便分次吃。",
  },
  {
    id: 6,
    name: "童年麦丽素",
    brand: "老铺子",
    tags: ["怀旧", "甜口"],
    surprise: 4.1,
    price: "¥6",
    note: "外壳脆、内芯麦芽奶香浓，纸盒包装保留旧时手感，怀旧党必拆。",
  },
  {
    id: 7,
    name: "藤椒味薯片",
    brand: "脆客",
    tags: ["辣味"],
    surprise: 4.4,
    price: "¥11",
    note: "藤椒的清香盖过了油感，片厚薄均匀，袋底碎渣很少。",
  },
  {
    id: 8,
    name: "抹茶麻薯",
    brand: "青野制果",
    tags: ["甜口"],
    surprise: 4.2,
    price: "¥14",
    note: "外皮软糯拉丝，抹茶味偏正不甜腻，冷藏后口感更好。",
  },
  {
    id: 9,
    name: "原味厚切薯片",
    brand: "山田农园",
    tags: ["咸香"],
    surprise: 3.8,
    price: "¥10",
    note: "只放海盐调味，土豆本身的味道清楚，喜欢纯粹口味的人会偏爱它。",
  },
  {
    id: 10,
    name: "陈皮话梅",
    brand: "甘之堂",
    tags: ["酸爽", "怀旧"],
    surprise: 4.0,
    price: "¥7",
    note: "酸中带陈皮香，果肉厚实，是路上提神醒神的小零食。",
  },
  {
    id: 11,
    name: "炭烤腰果",
    brand: "果之谷",
    tags: ["坚果"],
    surprise: 4.5,
    price: "¥20",
    note: "焦香明显，咸度比蜂蜜杏仁更高，颗粒饱满，几乎没有空壳。",
  },
  {
    id: 12,
    name: "黑糖脏脏包",
    brand: "麦穗烘焙",
    tags: ["甜口"],
    surprise: 4.7,
    price: "¥13",
    note: "黑糖味浓郁，表面可可粉扎实，甜度偏高，适合当一餐的甜点收尾。",
  },
];